<template>
  <div class="categories-filter-component">
    <div class="container py-4">
      <div class="d-flex justify-content-center flex-wrap">
        <button
          v-for="(type, i) in types"
          :key="i"
          class="mx-lg-3 mx-1 d-flex flex-column align-items-center"
          @click="addToArraySelected(type.id)"
        >
          <div
            class="d-flex justify-content-center align-items-center "
            :class="{
              'border-img': !checkSelected(type.id),
              'bg-active': checkSelected(type.id)
            }"
          >
            <i class="icon-size" :class="`${type.icon}`"></i>
          </div>
          <p class="pt-2">
            {{ type.text }}
          </p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoriesFilter",
  data() {
    return {
      selected: [],
      types: [
        {
          icon: "icon-library-music",
          text: "Todos",
          id: 1
        },
        {
          icon: "icon-Cross",
          text: "Hinos",
          id: "anthem"
        },
        {
          icon: "icon-church",
          text: "Cânticos",
          id: "chant"
        }
      ]
    };
  },
  watch: {
    selected(i) {
      this.checkSelected(i);
    }
  },
  methods: {
    addToArraySelected(i) {
      if (i == 1) {
        if (this.selected.includes(i)) return;
        else {
          this.selected = [];
          this.selected.push(i);
        }
      } else if (this.selected.includes(i)) {
        const index = this.selected.indexOf(i);
        this.selected.splice(index, 1);
        if (this.selected.length == 0) {
          this.selected.push(1);
        }
      } else if (this.selected.includes(1)) {
        this.selected = [];
        this.selected.push(i);
      } else if (this.selected.length > 0) {
        this.selected.shift();
        this.selected.push(i);
      } else {
        this.selected.push(i);
      }
      this.$emit("filterByTypes", { types: this.selected });
    },
    checkSelected(i) {
      return this.selected.includes(i);
    }
  },
  mounted() {
    this.selected.push(this.types[0].id);
  }
};
</script>

<style lang="scss" scoped>
.categories-filter-component {
  background-image: url("../../assets/images/repertories/categories-filter-bg.png");
  background-position: center center;
  background-size: cover;

  .icon-size {
    font-size: 35px;
    @media screen and (max-width: 992px) {
      font-size: 25px;
    }
  }

  button {
    background: none;
    border: none;
    color: #ffffff;
  }

  .border-img,
  .bg-active {
    border: 1px solid #ffffff;
    border-radius: 50%;
    width: 78px;
    height: 78px;

    @media screen and (max-width: 992px) {
      width: 62px;
      height: 62px;
    }
  }

  .bg-active {
    background-color: #2db563;
    border: none;
  }
}
</style>
